import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { TwoColumnLayoutModule } from 'src/app/common-components/column-layouts/two-column-layout/two-column-layout.module';
import { DetailLinksModule } from 'src/app/common-components/detail-links/detail-links.module';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { LcsSingleSelectModule } from 'src/app/common-components/entity-select/single-select/single-select.module';
import { FormFooterModule } from 'src/app/common-components/form-footer/form-footer.module';
import { UpdateDetailsModule } from 'src/app/common-components/update-details/update-details.module';
import { FormatNameLengthPipeModule } from 'src/app/pipes/format-name-length-pipe/call-cost-pipe.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { LocationModule } from 'src/app/pipes/location/location.module';
import { MergeDepartmentModule } from '../merge-department/merge-department.module';
import { ModifyDepartmentModule } from '../modify-department/modify-department.module';
import { DepartmentDetailComponent } from './containers/department-detail.component';
import { DepartmentDetailEffects } from './state/department-detail.effects';
import * as fromDepartmentDetail from './state/department-detail.reducer';
import { DepartmentDetailViewComponent } from './views/department-detail-view.component';
@NgModule({
   declarations: [DepartmentDetailViewComponent, DepartmentDetailComponent],
   exports: [DepartmentDetailComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      FormatPhoneNumbersPipeModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatInputModule,
      MatIconModule,
      MatMenuModule,
      MatButtonModule,
      MatTooltipModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      LcsCallStatePipeModule,
      TwoColumnLayoutModule,
      FormFooterModule,
      MatSelectModule,
      LocationModule,
      LcsSingleSelectModule,
      EntitySelectModule,
      MatTabsModule,
      ModifyDepartmentModule,
      MergeDepartmentModule,
      RouterModule,
      DetailLinksModule,
      UpdateDetailsModule,
      ScrollingModule,
      MatDividerModule,
      FormatNameLengthPipeModule,
      StoreModule.forFeature(fromDepartmentDetail.departmentDetailFeatureKey, fromDepartmentDetail.reducer),
      EffectsModule.forFeature([DepartmentDetailEffects]),
      AppRoutingModule,
      UpdateDetailsModule,
   ],
})
export class DepartmentDetailModule {}
